import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { getVisibleDefaultShifts } from 'modules/shift_management/lib/getVisibleDefaultShifts'
import { DefaultShift } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

export type DefaultShiftsState = {
  defaultShifts: DefaultShift[]
  activeDefaultShifts: DefaultShift[]
  visibleDefaultShifts: DefaultShift[]
  contractVersions: ContractVersions
}

export type DefaultShiftsDispatch = (arg0: DefaultShiftsAction) => void

export type DefaultShiftsAction =
  | {
      type: 'BOOTSTRAP'
      defaultShifts: DefaultShifts | undefined
    }
  | {
      type: 'ADD_DEFAULT_SHIFT'
      defaultShift: DefaultShift | undefined
    }

export function initialDefaultShiftsState(contractVersions: ContractVersions): DefaultShiftsState {
  return {
    defaultShifts: [],
    activeDefaultShifts: [],
    visibleDefaultShifts: [],
    contractVersions,
  }
}

const builder = (
  defaultShifts: DefaultShift[],
  contractVersions: ContractVersions
): DefaultShiftsState => {
  const currentEmployee = users.current.employee
  const activeDefaultShifts = defaultShifts.filter((ds) => ds.isActive)
  const visibleDefaultShifts = currentEmployee
    ? getVisibleDefaultShifts(currentEmployee, activeDefaultShifts, contractVersions)
    : activeDefaultShifts

  return { defaultShifts, activeDefaultShifts, visibleDefaultShifts, contractVersions }
}

export default function reducer(
  state: DefaultShiftsState,
  action: DefaultShiftsAction
): DefaultShiftsState {
  switch (action.type) {
    case 'BOOTSTRAP': {
      const defaultShifts: DefaultShift[] = !!action.defaultShifts
        ? action.defaultShifts.all
        : state.defaultShifts

      return builder(defaultShifts, state.contractVersions)
    }

    case 'ADD_DEFAULT_SHIFT': {
      const currentDefaultShifts = state.defaultShifts
      const defaultShifts = !!action.defaultShift
        ? currentDefaultShifts.concat(action.defaultShift)
        : currentDefaultShifts

      return builder(defaultShifts, state.contractVersions)
    }

    default:
      return state
  }
}
